var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default {
    state: {
        searchParams: {
            statuses: [],
            occupationStatus: '',
            pattern: '1',
            startDate: '',
            endDate: '',
            tenantPlaceIdList: [],
            categoryIds: [],
            cityIdList: [],
            labelIdList: [],
        },
    },
    actions: {},
    mutations: {
        // 更新登录用户信息
        UPDATE_SCHEDULE_SEARCH_PARAMS: function (state, data) {
            state.searchParams = __assign(__assign({}, state.searchParams), data);
        },
    },
    getters: {
        getScheduleSearchParams: function (state) {
            return state.searchParams || {};
        },
    },
};
